import { Outlet } from 'react-router';
import { Navbar } from '@/components/navbar';
import { Footer } from '@/components/footer';

export function LandingLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      {/* WCAG 2.4.1 — Skip link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-sm focus:bg-peninsula-graphite focus:px-4 focus:py-2 focus:text-white focus:text-sm focus:font-medium focus:ring-2 focus:ring-peninsula-magma"
      >
        Saltar al contenido principal
      </a>

      <Navbar />

      <main id="main-content" className="flex-1">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
